import styled from "styled-components";

import bookPath from "../../assets/images/book.png";

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  min-height: 100vh;
  background: url(${bookPath}) 32px 32px no-repeat;
  background-color: #f1f7f8;
`;

export const LayoutMain = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
